import React, { useEffect, useState } from 'react';

import useSingleCventContactUpdateConflict from './_hooks/useSingleCventContactUpdateConflict';
import usePrevious from '@hooks/usePrevious';

import { ContactUpdateConflictPostBody } from '@customTypes/shared/Contact';

import ConfirmModal from '@components/modal/ConfirmModal';
import ErrorModal from '@components/modal/ErrorModal';

const CventContactUpdateConflictModal: React.FC<ModalProps> = ({
    visible,
    handleClose,
    postBody,
}) => {
    const [showError, setShowError] = useState(false);
    const { isPosting, postError, handleSubmit } = useSingleCventContactUpdateConflict(postBody);
    const prevProps = usePrevious({ postError });

    useEffect(() => {
        if (postError && !prevProps.postError && visible) {
            setShowError(true);
        }
    }, [postError, prevProps.postError, visible]);

    if (!visible) return null;

    if (showError)
        return <ErrorModal description={postError || undefined} closeModal={closeError} />;

    return (
        <ConfirmModal
            description="Are you sure you would like to use this entry?"
            isPosting={isPosting}
            handleSubmit={handleSubmit}
            closeModal={handleClose}
        />
    );

    function closeError(): void {
        setShowError(false);
        handleClose();
    }
};

interface ModalProps {
    visible: boolean;
    handleClose: () => void;
    postBody: ContactUpdateConflictPostBody;
}

export default CventContactUpdateConflictModal;
